import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { LayoutServiceContext } from '@sitecore-content-sdk/nextjs';
import { getBrandForSiteName } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { SiteName } from 'lib/constants/brand-theme-site';
import { Environment, getEnvironment } from 'lib/services/utils/utils';
import { Brands } from 'lib/themes';

export interface GlobalData {
  siteName: SiteName;
  brand: Brands;
  environment: Environment;
  locale: string;
}

export function useGlobalData(): GlobalData {
  const { page } = useSitecore();
  const sitecoreContext = page?.layout?.sitecore?.context;
  return getGlobalData(sitecoreContext);
}

export function getGlobalData(sitecoreContext?: LayoutServiceContext): GlobalData {
  const siteName = (sitecoreContext?.site?.name as SiteName) ?? 'WhiteLabel';

  // Access custom context fields via index signature (they are added server-side by page-props plugins)
  const ctx = sitecoreContext as Record<string, unknown> | undefined;
  const siteSettings = ctx?.siteSettings as Record<string, unknown> | undefined;
  const brand =
    ((siteSettings?.brandStyle as Record<string, unknown> | undefined)?.value as Brands) ||
    getBrandForSiteName(siteName) ||
    'BrandsWhiteLabel';

  return {
    siteName,
    brand,
    environment: getEnvironment(),
    locale: sitecoreContext?.language ?? 'en-US',
  };
}
